import { render, staticRenderFns } from "./UpdatesCard.vue?vue&type=template&id=14a96355&scoped=true"
import script from "./UpdatesCard.vue?vue&type=script&lang=js"
export * from "./UpdatesCard.vue?vue&type=script&lang=js"
import style0 from "./UpdatesCard.vue?vue&type=style&index=0&id=14a96355&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a96355",
  null
  
)

export default component.exports